/*
 * Copyright (C) 2019 - present Marek Kuzora - All Rights Reserved.
 */


import Base from 'shared/client/routes/base';


export default class extends Base
{
  isRouteVisible ()
  {
    return this.isZoneLocation() && this.isUserOwner();
  }
};
